import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, Map, PenTool, FolderOpen, 
  LogOut, ChevronRight, UserCog 
} from 'lucide-react';

export default function EditorSidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token"); // Admin panel 'token' kullanıyor, burayı da güncelledim
    localStorage.removeItem("userRole");
    navigate("/login"); // Veya /editor-login
  };

  // İkonları component referansı olarak geçiyoruz (daha kolay stil vermek için)
  const menuItems = [
    { name: 'Panel Özeti', path: '/editor/dashboard', icon: LayoutDashboard },
    { name: 'Rota Oluştur', path: '/editor/create-route', icon: Map },
    { name: 'Blog Yaz', path: '/editor/write-blog', icon: PenTool },
    { name: 'İçeriklerim', path: '/editor/my-contents', icon: FolderOpen },
  ];

  return (
    <>
      {/* Scrollbar Stilleri (Admin Panel ile aynı) */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background-color: #334155; border-radius: 20px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #475569; }
      `}</style>

      <aside className="w-72 bg-[#0f172a] text-gray-300 min-h-screen flex flex-col border-r border-gray-800 shadow-xl">
        
        {/* --- LOGO ALANI --- */}
        <div className="h-20 flex items-center gap-3 px-6 border-b border-gray-800/50 bg-[#0f172a]/50 backdrop-blur-sm sticky top-0 z-10">
          <div className="p-2 bg-indigo-600 rounded-lg shadow-lg shadow-indigo-500/30">
            {/* Editör Paneli olduğu için PenTool ikonu kullanabiliriz veya marka için MapPin kalabilir */}
            <PenTool className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white tracking-tight">Mekânname</h2>
            <span className="text-xs text-indigo-400 font-medium tracking-wide">EDİTÖR PANELİ</span>
          </div>
        </div>

        {/* --- MENÜ LİNKLERİ --- */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden py-6 px-4 space-y-1 custom-scrollbar">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `relative flex items-center justify-between py-3 px-4 rounded-xl transition-all duration-200 group mb-1
                ${isActive 
                  ? "bg-indigo-600 text-white shadow-md shadow-indigo-900/20" 
                  : "text-gray-400 hover:bg-gray-800 hover:text-gray-100"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className="flex items-center gap-3">
                    {/* İkon Rengi Geçişi */}
                    <item.icon 
                      size={20} 
                      className={`transition-colors ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'}`} 
                    />
                    <span className="font-medium text-sm">{item.name}</span>
                  </div>
                  
                  {/* Aktif İndikatörü */}
                  {isActive && <ChevronRight size={16} className="text-indigo-200" />}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* --- ALT KISIM (ÇIKIŞ) --- */}
        <div className="p-4 border-t border-gray-800 bg-[#0f172a]">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full px-4 py-3 rounded-xl transition-all duration-200 text-red-400 hover:bg-red-500/10 hover:text-red-300 group"
          >
            <LogOut size={20} className="transition-transform group-hover:-translate-x-1" />
            <span className="font-medium text-sm">Çıkış Yap</span>
          </button>
        </div>
      </aside>
    </>
  );
}